import { TheosApi } from "./modules/TheosApi";
import { _configuration } from "./feim/configuration";
import { addSupportedApi } from "./feim/messageProcessor";
import { debug } from "./feim/debug";
import { handleIdlePause } from "./modules/handleIdlePause";
import { handleNavigateGame } from "./modules/handleNavigateGame";
import { initializeRcIframe } from "./modules/realityCheckIframe";

export {
    debug
};

export { configure, getConfiguration } from "./feim/configuration";
export * from "./feim/api";
export * from "./feim/types";
export { LogLevel } from "./utils/log";
export { showError} from "./modules/showError";

declare global {
    interface Window {
        rlxfeim: {
            verifyConfiguration: () => boolean;
            log: string[];
        };
    }
}

window.rlxfeim = {
    verifyConfiguration: debug.verifyConfiguration,
    // Only populated if &rlxfeimdebug is present
    log: [],
};

// Other possible APIs are checked if the game configures them to be handled
addSupportedApi(new TheosApi());

// Pause will only trigger in-game once any unfinished round has ended
handleIdlePause();

// Redirect game window on navigate game event
handleNavigateGame();

// Creates the RC iframe if rciframeurl is present
initializeRcIframe();